import parse from "html-react-parser";
import Image from "next/image";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";

import styles from "./hero-products.module.scss";

export function HeroProducts() {
  const { t } = useTranslation("common");
  const pvc = t("products.pvc").split(" ");
  const pvcInit = pvc
    .slice()
    .splice(0, pvc.length - 1)
    .join(" ");
  const pvcPop = pvc.slice().splice(-1);
  const pvcName =
    pvc.length > 1
      ? `${pvcInit} <span>${pvcPop}</span>`
      : `<span>${pvc[0]}</span>`;

  const alu = t("products.alu").split(" ");
  const AluInit = alu
    .slice()
    .splice(0, alu.length - 1)
    .join(" ");
  const aluPop = alu.slice().splice(-1);
  const aluName =
    alu.length > 1
      ? `${AluInit} <span>${aluPop}</span>`
      : `<span>${alu[0]}</span>`;

  const rollers = t("products.rollers").split(" ");
  const rollersInit = rollers
    .slice()
    .splice(0, rollers.length - 1)
    .join(" ");
  const rollersPop = rollers.slice().splice(-1);
  const rollersName =
    rollers.length > 1
      ? `${rollersInit} <span>${rollersPop}</span>`
      : `<span>${rollers[0]}</span>`;

  const pergolas = t("products.pergolas").split(" ");
  const pergolasInit = pergolas
    .slice()
    .splice(0, pergolas.length - 1)
    .join(" ");
  const pergolasPop = pergolas.slice().splice(-1);
  const pergolasName =
    pergolas.length > 1
      ? `${pergolasInit} <span>${pergolasPop}</span>`
      : `<span>${pergolas[0]}</span>`;
  return (
    <div className="relative bg-white px-1 sm:px-2">
      <div className="mx-auto max-w-screen-2xl py-4">
        <div
          className="grid grid-cols-1 justify-evenly gap-1 sm:grid-cols-2 lg:grid-cols-4"
          id="main"
        >
          <div className={`w-full p-1 ${styles.item}`}>
            <figure className={styles.effect}>
              <Image alt=".." height={462} src="/img/pvc.jpg" width={640} />
              <figcaption>
                <div>
                  <h2>{parse(pvcName || "")}</h2>
                  {/* <p>{t('products.pvcDesc')}</p> */}
                </div>
                <Link href="/pvc">{t("products.pvc")}</Link>
              </figcaption>
            </figure>
          </div>
          <div className={`w-full p-1 ${styles.item}`}>
            <figure className={styles.effect}>
              <Image alt=".." height={462} src="/img/alu.jpg" width={640} />
              <figcaption>
                <div>
                  <h2>{parse(aluName || "")}</h2>
                  {/* <p>{t('products.aluDesc')}</p> */}
                </div>
                <Link href="/alu">{t("products.alu")}</Link>
              </figcaption>
            </figure>
          </div>
          <div className={`w-full p-1 ${styles.item}`}>
            <figure className={styles.effect}>
              <Image alt=".." height={462} src="/img/rollers.jpg" width={640} />
              <figcaption>
                <div>
                  <h2>{parse(rollersName || "")}</h2>
                  {/* <p>{t('products.rollersDesc')}</p> */}
                </div>
                <Link href="/rollers">{t("products.rollers")}</Link>
              </figcaption>
            </figure>
          </div>
          <div className={`w-full p-1 ${styles.item}`}>
            <figure className={styles.effect}>
              <Image
                alt=".."
                height={462}
                src="/img/pergolas.jpg"
                width={640}
              />
              <figcaption>
                <div>
                  <h2>{parse(pergolasName || "")}</h2>
                  {/* <p>{t('products.pergolasDesc')}</p> */}
                </div>
                <Link href="/pergolas">{t("products.pergolas")}</Link>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </div>
  );
}
